import { TabStyles } from '@tableau/widgets';
import { style } from 'typestyle';
import { NestedCSSProperties } from 'typestyle/lib/types';

const inputSectionStyle: NestedCSSProperties = {
  marginBottom: `${TabStyles.Spacing.LargeSpace}px`,
  width: '100%',
  $nest: {
    'input, textarea': {
      width: '100%',
      resize: 'none',
    },
    label: {
      fontWeight: 'bold',
    },
    /* Chrome, Safari, Edge, Opera */
    'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    /* Firefox */
    'input[type=number]': {
      '-moz-appearance': 'textfield',
    },
  },
};

const comparisonInputStyle: NestedCSSProperties = {
  marginBottom: '3px',
};

export const inputSection = style(inputSectionStyle);

export const comparisonInput = style(inputSectionStyle, comparisonInputStyle);

export const customDateWindow = style({
  marginBottom: `${TabStyles.Spacing.LargeSpace}px`,
  fontWeight: 'normal',
  $nest: {
    '>label>div': {
      overflow: 'visible',
    },
  },
});
